import React from 'react';
import Document from "../common/Document";
import { DocumentType } from "../../enums/DocumentType";

const PhysicianDocument = () => {
    return (
        <Document documentTypeOptions={[DocumentType.PHYSICIAN_STATEMENT, DocumentType.MEDICAL_RECORDS]}/>
    )
};

export default PhysicianDocument;